import React from 'react';
import Button from '@/components/ui/Button.jsx';
import supportService from '@/services/supportService.js';

export default function SupportRequestThread({ ticketId, isFrench = false }) {
  const [open, setOpen] = React.useState(false);
  const [ticket, setTicket] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');
  const [message, setMessage] = React.useState('');
  const fr = isFrench;
  const panelId = `support-thread-${ticketId}`;
  const fail = fr ? 'Impossible de charger ou d’envoyer la réponse. Réessayez.' : 'The conversation could not be loaded or the reply sent. Please retry.';
  async function load() {
    setBusy(true); setError('');
    try {
      const result = await supportService.getTicket(ticketId);
      if (result.error || !result.data) setError(fail); else setTicket(result.data);
    } catch { setError(fail); } finally { setBusy(false); }
  }
  React.useEffect(() => { if (open) void load(); }, [open, ticketId]);
  async function reply(event) {
    event.preventDefault(); if (!message.trim() || busy) return;
    setBusy(true); setError('');
    try {
      const result = await supportService.addTicketMessage(ticketId, message.trim());
      if(result.error) { setError(fail); return; }
      setMessage(''); await load();
    } catch { setError(fail); } finally { setBusy(false); }
  }
  return <div className="mt-4">
    <Button variant="tonal" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(!open)}>
      {open ? (fr ? 'Masquer les réponses' : 'Hide replies') : (fr ? 'Voir la demande et les réponses' : 'View request and replies')}
    </Button>
    {open && <div id={panelId} className="mt-4 space-y-4">
      {error && <p role="alert" className="text-body-medium">{error}</p>}
      {busy && <p role="status">{fr ? 'Chargement…' : 'Loading…'}</p>}
      <Button variant="text" onClick={load} disabled={busy}>{fr ? 'Actualiser' : 'Refresh'}</Button>
      {ticket && <>
        <ol className="space-y-3" aria-label={fr ? 'Réponses de la demande' : 'Request replies'}>
          {(ticket.messages || []).filter(m => !m.is_internal).sort((a,b) => String(a.created_at).localeCompare(String(b.created_at))).map(m => <li key={m.id} className="border-t pt-3 text-body-medium">
            <p className="font-medium">{m.sender_name || (fr ? 'Assistance AfriMed™' : 'AfriMed™ Support')}</p>
            <p className="whitespace-pre-wrap break-words">{m.message}</p>
            <time className="text-body-small text-on-surface-var" dateTime={m.created_at}>{new Date(m.created_at).toLocaleString(fr ? 'fr-FR' : 'en-GB')}</time>
          </li>)}
        </ol>
        {!ticket.messages?.some(m => !m.is_internal) && <p>{fr ? 'Aucune réponse pour le moment.' : 'No replies yet.'}</p>}
        <form onSubmit={reply} className="space-y-3">
          <label className="block" htmlFor={`${panelId}-reply`}>{fr ? 'Votre réponse' : 'Your reply'}</label>
          <textarea id={`${panelId}-reply`} className="w-full rounded-xl border p-3 text-body-medium" rows={3} required maxLength={5000} value={message} onChange={e => setMessage(e.target.value)} />
          <Button type="submit" disabled={busy || !message.trim()}>{fr ? 'Envoyer la réponse' : 'Send reply'}</Button>
        </form>
      </>}
    </div>}
  </div>;
}
